import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const qs = new URLSearchParams(window.location.search);
      const code = qs.get("code");
      const state = qs.get("state");
      const expectedState = sessionStorage.getItem("g_oauth_state");
      const returnTo = sessionStorage.getItem("g_oauth_return") || "/";
      sessionStorage.removeItem("g_oauth_state");
      sessionStorage.removeItem("g_oauth_return");

      if (!code || !state || state !== expectedState) {
        navigate(returnTo, { replace: true });
        return;
      }
      try {
        const res = await axios.post(`${API}/user-auth/google/exchange`, {
          code,
          redirect_uri: window.location.origin + "/auth/google",
        });
        if (res.data.session_token) {
          localStorage.setItem("ai_tools_token", res.data.session_token);
        }
        sessionStorage.setItem("user_data", JSON.stringify(res.data));
        navigate(returnTo, { replace: true, state: { user: res.data } });
      } catch (err) {
        console.error("Google auth failed:", err);
        navigate(returnTo, { replace: true });
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="google-auth-callback">
      <div className="text-center">
        <Loader2 size={40} className="text-[#00F0FF] animate-spin mx-auto mb-4" />
        <p className="text-zinc-400 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
